import { Label } from "@src/components/Typography";
import { VStack } from "@src/components/VStack";
import React from "react";

import { Controller, useFormContext, type FieldError } from "react-hook-form"

import type { StripeFormFieldsProps } from "./interface";
import { HStack } from "@src/components/HStack";
import { Box } from "@src/components/Box";
import { CardNumberField, CVCField, ExpirationDateField } from "./StripeCommonTextFields.web";
import { getTestId } from "@src/utils/testIds";

export const StripeFormFields = ({
  disabled,
  helperText,
  placeholder,
  debitCardName = 'debit_card_number',
  expirationDateName = 'expiration_date',
  cvcName = 'cvc',
  ...rest
}: StripeFormFieldsProps) => {
  const { control } = useFormContext() ?? {};

  const getHelperText = (error: FieldError | undefined) => {
    const parsedError = error || undefined;
    return parsedError ? parsedError.message : helperText;
  };

  return (
    <Box>
      <Controller
        control={control}
        name={debitCardName}
        render={({ field: { onChange, value: fieldValue }, fieldState: { error } }) => (
          <VStack>
            <Label size="s">Card number</Label>
            <CardNumberField
              error={!!error}
              fullWidth
              helperText={getHelperText(error)}
              disabled={disabled}
              onChange={onChange}
              placeholder={placeholder}
              value={fieldValue}
              data-testid={getTestId(rest)}
            />
          </VStack>
        )}
      />

      <HStack gap={1} mt={1}>
        <Controller
          control={control}
          name={expirationDateName}
          render={({ field: { onChange, value: fieldValue }, fieldState: { error } }) => (
            <VStack width='50%'>
              <Label size="s">Exp Date</Label>
              <ExpirationDateField
                error={!!error}
                fullWidth
                helperText={getHelperText(error)}
                disabled={disabled}
                onChange={onChange}
                placeholder={placeholder}
                value={fieldValue}
                data-testid={getTestId(rest)}
              />
            </VStack>
          )}
        />
        <Controller
          control={control}
          name={cvcName}
          render={({ field: { onChange, value: fieldValue }, fieldState: { error } }) => (
            <VStack width='50%'>
              <Label size="s">CVC</Label>
              <CVCField
                error={!!error}
                fullWidth
                helperText={getHelperText(error)}
                disabled={disabled}
                onChange={onChange}
                placeholder={placeholder}
                value={fieldValue}
                data-testid={getTestId(rest)}
              />
            </VStack>
          )}
        />
      </HStack>
    </Box>
  )
}